export default __webpack_public_path__ + "static/media/python.2277a0b1.png";